<template>
  <section class="contact-us-container" id="contact">
    <div class="contact-us">
      <h2 class="visuallyhidden">Contact Us</h2>
      <div class="text">
        <h2>Contact Us</h2>
        <div class="page-break"></div>
        <h3 class="emphasis">Postal Address</h3>
        <address>
          138 Marshall St. 3rd Fl. <br />Elizabeth, New Jersey 07206
        </address>
        <h3 class="emphasis">Phone</h3>
        <a href="tel:+13174562564">1-908-821-4456</a>
        <h3 class="emphasis">Email</h3>
        <a href="mailto:info@wiretowirellc.com">Info@wiretowirellc.com</a>
      </div>
      <div class="form">
        <form id="form" @submit.prevent="sendEmail">
          <input
            v-model="name"
            type="text"
            placeholder="Name *"
            autocomplete="name"
            required
          />
          <input
            v-model="email"
            type="email"
            placeholder="Email *"
            autocomplete="email"
            required
          />
          <input
            v-model="subject"
            type="text"
            placeholder="Subject (Eg. Inquiry, Greetings, etc.) *"
            required
          />
          <textarea id="message" v-model="message" required></textarea>
          <button type="submit" class="button">
            {{ sent ? 'Email Sent!' : 'Submit' }}
            <div class="sk-circle" v-show="sending">
              <div class="sk-circle1 sk-child"></div>
              <div class="sk-circle2 sk-child"></div>
              <div class="sk-circle3 sk-child"></div>
              <div class="sk-circle4 sk-child"></div>
              <div class="sk-circle5 sk-child"></div>
              <div class="sk-circle6 sk-child"></div>
              <div class="sk-circle7 sk-child"></div>
              <div class="sk-circle8 sk-child"></div>
              <div class="sk-circle9 sk-child"></div>
              <div class="sk-circle10 sk-child"></div>
              <div class="sk-circle11 sk-child"></div>
              <div class="sk-circle12 sk-child"></div>
            </div>
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',
      sending: false,
      sent: false,
    };
  },
  methods: {
    sendEmail() {
      this.sending = true;
      fetch('https://wiretowirellc.com/.netlify/functions/email', {
        method: 'post',
        mode: 'no-cors',
        body: JSON.stringify(this.$data),
      })
        .then((res) => {
          this.sent = true;
          this.sending = false;

          if (res.ok) {
            this.sent = true;
            this.name = '';
            this.email = '';
            this.subject = '';
            this.message = '';
          }
        })
        .catch((err) => {
          console.log('Error: ', err);
        });

      window.setTimeout(() => {
        this.sent = false;
        this.sending = false;
      }, 5000);
    },
  },
};
</script>

<style lang='scss' scoped></style>
